<template>
  <div class="cadfm-container-horizontal">
    <Left  v-show="isVisibleLeft" :lang="lang.Left"></Left>
    <Middle  :lang="lang.Middle"></Middle>
    <Right v-show="isVisibleRight"  :lang="lang.Right"></Right>
 </div>
</template>

<script>
import Left from '@/components/PartManager/Views/PartSearch/Left/Left'
import Middle from '@/components/PartManager/Views/PartSearch/Middle/Middle'
import Right from '@/components/PartManager/Views/PartSearch/Right/Right'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'PartSearch',
  components:{
    Left,
    Middle,
    Right
  },
  props:{
    routingData: Object,
    lang: Object
  },
  data () {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    }
  },
  methods: {

  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartSearch.vue